'use strict';
var NATIVE_BIND = require('../internals/function-bind-native');

var call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/function-call.js
// module id = 67
// module chunks = 22